document.addEventListener('DOMContentLoaded', () => {
  // Sticky header
  const header = document.querySelector('.header');

  if (header) {
    // Получаем изначальную позицию header'а
    const headerInitialTop = header.offsetTop;
    let isSticky = false;

    window.addEventListener('scroll', () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > headerInitialTop && !isSticky) {
        document.body.classList.add('sticky-header');
        isSticky = true;
      } else if (scrollTop <= headerInitialTop && isSticky) {
        document.body.classList.remove('sticky-header');
        isSticky = false;
      }
    });
  }

  // Mobile menu toggle
  const headerMenuBtn = document.querySelector('.header__menu-btn');

  if (headerMenuBtn) {
    const dropdownMenu = headerMenuBtn.nextElementSibling;

    headerMenuBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Toggle button active state (for icon animation)
      this.classList.toggle('active');

      // Toggle dropdown menu visibility
      if (dropdownMenu) {
        const wasHidden = dropdownMenu.classList.contains('_hidden');

        // Close all other dropdowns first
        document.querySelectorAll('.dropdown-menu').forEach((dropdown) => {
          dropdown.classList.add('_hidden');
          dropdown.classList.remove('!_block');
        });

        // Remove active class from all menu buttons
        document.querySelectorAll('.header__menu-btn').forEach((btn) => {
          btn.classList.remove('active');
        });

        if (wasHidden) {
          dropdownMenu.classList.remove('_hidden');
          dropdownMenu.classList.add('!_block');
          this.classList.add('active');
        }
      }
    });

    // Close menu when clicking outside
    document.body.addEventListener('click', (e) => {
      if (!e.target.closest('.header__menu-btn') && !e.target.closest('.dropdown-menu')) {
        if (headerMenuBtn.classList.contains('active')) {
          headerMenuBtn.classList.remove('active');
        }

        if (dropdownMenu) {
          dropdownMenu.classList.add('_hidden');
          dropdownMenu.classList.remove('!_block');
        }
      }
    });
  }
});
